<div class="container">
    <mat-card class="mat-elevation-z8 w-100">
        <div class="row card-border pt-2 pb-2">
            <div class="col-8">
                <h2>Formulário de cadastro</h2>
            </div>
        </div>
        <form class="row mt-2" [formGroup]="form">
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="name" [errorStateMatcher]="matcher">
                    <mat-error *ngIf="form.controls.name.invalid">
                        Nome é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Fórmula</mat-label>
                    <input type="text" placeholder="Pesquisar..." matInput formControlName="formule" [matAutocomplete]="auto_formule">
                    <mat-autocomplete autoActiveFirstOption #auto_formule="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let formule of filteredOptionsFormule | async" [value]="formule">
                          {{formule.name}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.name.invalid">
                        Fórmula é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Tabela Origem</mat-label>
                    <input type="text" placeholder="Pesquisar..." matInput formControlName="table_origin" [matAutocomplete]="auto_table_origin">
                    <mat-autocomplete autoActiveFirstOption #auto_table_origin="matAutocomplete" (optionSelected)="getColumnTableOriginList()">
                        <mat-option *ngFor="let table of filteredOptions | async" [value]="table.name">
                          {{table.name}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.table_origin.invalid">
                        Tabela Origem é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Coluna Origem</mat-label>
                    <input type="text" placeholder="{{form.controls.table_origin.invalid ? 'Escolha uma Tabela de Origem' : 'Pesquisar...'}}" matInput formControlName="column_origin" [matAutocomplete]="auto_column_origin">
                    <mat-autocomplete autoActiveFirstOption #auto_column_origin="matAutocomplete">
                        <mat-option *ngFor="let column of filteredOptionsColumnOrigin | async" [value]="column">
                          {{column}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.column_origin.invalid">
                        Coluna Origem é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Tabela Destino</mat-label>
                    <input type="text" placeholder="Pesquisar..." matInput formControlName="table_destination" [matAutocomplete]="auto_table_destination">
                    <mat-autocomplete autoActiveFirstOption #auto_table_destination="matAutocomplete" (optionSelected)="getColumnTableDestinationList()">
                        <mat-option *ngFor="let table of filteredOptionsTableDestination | async" [value]="table.name">
                          {{table.name}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.table_destination.invalid">
                        Tabela Destino é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Coluna Destino</mat-label>
                    <input type="text" placeholder="{{form.controls.table_destination.invalid ? 'Escolha uma Tabela de Destino' : 'Pesquisar...'}}" matInput formControlName="column_destination" [matAutocomplete]="auto_column_destination">
                    <mat-autocomplete  autoActiveFirstOption #auto_column_destination="matAutocomplete">
                        <mat-option *ngFor="let column of filteredOptionsColumnDestination | async" [value]="column">
                          {{column}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.column_destination.invalid">
                        Coluna Destino é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Relação Origem</mat-label>
                    <input type="text" placeholder="Pesquisar..." matInput formControlName="origin_relationship" [matAutocomplete]="auto_origin_relationship">
                    <mat-autocomplete  autoActiveFirstOption #auto_origin_relationship="matAutocomplete">
                        <mat-option *ngFor="let column of filteredOptionsTableColumnOrigin | async" [value]="column.name">
                          {{column.name}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.origin_relationship.invalid">
                        Relação Origem é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <mat-label>Relação Destino</mat-label>
                    <input type="text" placeholder="Pesquisar..." matInput formControlName="destination_relationship" [matAutocomplete]="auto_destination_relationship">
                    <mat-autocomplete  autoActiveFirstOption #auto_destination_relationship="matAutocomplete">
                        <mat-option *ngFor="let column of filteredOptionsTableColumnDestination | async" [value]="column.name">
                          {{column.name}}
                        </mat-option>
                      </mat-autocomplete>
                    <mat-error *ngIf="form.controls.destination_relationship.invalid">
                        Realção Destino é <strong>obrigatório</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6 text-left mt-3">
                <button mat-flat-button color="basic" (click)="back()" matTooltip="Voltar"
                    skipLocationChange>
                    <i class="fa fa-arrow-left fa-1x btnIcon"></i> Voltar
                </button>
            </div>
            <div class="col-6 text-right mt-3">
                <button mat-flat-button color="primary" (click)="saveAll()" matTooltip="Gravar Regra"
                    skipLocationChange>
                    <i class="fa fa-floppy-o fa-1x btnIcon"></i> Gravar Regra
                </button>
            </div>
        </form>
    </mat-card>
</div>